// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1Tdxo","active":"NavigationItem_active__1r5wL"};